export const LOAD_OFFER_ASSETS_SUCCEEDED = 'LOAD_OFFER_ASSETS_SUCCEEDED';
export const LOAD_OFFER_ASSET_SUCCEEDED = 'LOAD_OFFER_ASSET_SUCCEEDED';
export const LOAD_OFFER_ASSETS_STARTED = 'LOAD_OFFER_ASSETS_STARTED';
export const LOAD_OFFER_ASSETS_FAILED = 'LOAD_OFFER_ASSETS_FAILED';

export const LOAD_OFFER_ASSETS_HEADER_STARTED = 'LOAD_OFFER_ASSETS_HEADER_STARTED';
export const LOAD_OFFER_ASSETS_HEADER_SUCCEEDED = 'LOAD_OFFER_ASSETS_HEADER_SUCCEEDED';
export const LOAD_OFFER_ASSETS_HEADER_FAILED = 'LOAD_OFFER_ASSETS_HEADER_FAILED';
export const LOAD_ASSET_PROPERTIES_STARTED = 'LOAD_ASSET_PROPERTIES_STARTED';
export const LOAD_ASSET_PROPERTIES_SUCCEEDED = 'LOAD_ASSET_PROPERTIES_SUCCEEDED';

export const SAVE_OFFER_ASSET_STARTED = 'SAVE_OFFER_ASSET_STARTED';
export const SAVE_OFFER_ASSET_SUCCEEDED = 'SAVE_OFFER_ASSET_SUCCEEDED';
export const SAVE_OFFER_ASSET_FAILED = 'SAVE_OFFER_ASSET_FAILED';

export const CANCEL_OFFER_ASSET_CHANGES = 'CANCEL_OFFER_ASSET_CHANGES';

export const SET_ASSET_IN_EDIT = 'SET_ASSET_IN_EDIT';
export const SET_ASSET_DIRTY = 'SET_ASSET_DIRTY';
export const CHANGE_ASSET_PROPERTY = 'CHANGE_ASSET_PROPERTY';
export const VALIDATE_ASSET = 'VALIDATE_ASSET';

export const DELETE_OFFER_ASSET_STARTED = 'DELETE_OFFER_ASSET_STARTED';
export const DELETE_OFFER_ASSET_FAILED = 'DELETE_OFFER_ASSET_FAILED';
export const DELETE_OFFER_ASSET_SUCCEEDED = 'DELETE_OFFER_ASSET_SUCCEEDED';

export const DUPLICATE_OFFER_ASSET_STARTED = 'DUPLICATE_OFFER_ASSET_STARTED';
export const DUPLICATE_OFFER_ASSET_FAILED = 'DUPLICATE_OFFER_ASSET_FAILED';
export const DUPLICATE_OFFER_ASSET_SUCCEEDED = 'DUPLICATE_OFFER_ASSET_SUCCEEDED';

export const UPDATE_OFFER_ASSET_CHASSIS_NUMBER_SUCCESS = 'UPDATE_OFFER_ASSET_CHASSIS_NUMBER_SUCCESS';
export const UPDATE_OFFER_ASSET_CHASSIS_NO_STARTED = 'UPDATE_OFFER_ASSET_CHASSIS_NO_STARTED';
export const UPDATE_OFFER_ASSET_CHASSIS_CANCELED = 'UPDATE_OFFER_ASSET_CHASSIS_CANCELED';

export const SPLIT_OFFER_ASSET_STARTED = 'SPLIT_OFFER_ASSET_STARTED';
export const SPLIT_OFFER_ASSET_SUCCEEDED = 'SPLIT_OFFER_ASSET_SUCCEEDED';
export const SPLIT_OFFER_ASSET_FAILED = 'SPLIT_OFFER_ASSET_FAILED';

export const SAVE_OFFER_ASSET_INFORMATION_STARTED = 'SAVE_OFFER_ASSET_INFORMATION_STARTED';
export const SAVE_OFFER_ASSET_INFORMATION_SUCCEEDED = 'SAVE_OFFER_ASSET_INFORMATION_SUCCEEDED';
export const SAVE_OFFER_ASSET_INFORMATION_FAILED = 'SAVE_OFFER_ASSET_INFORMATION_FAILED';

export const DELETE_OFFER_ASSET_INFORMATION_STARTED = 'DELETE_OFFER_ASSET_INFORMATION_STARTED';
export const DELETE_OFFER_ASSET_INFORMATION_SUCCEEDED = 'DELETE_OFFER_ASSET_INFORMATION_SUCCEEDED';
export const DELETE_OFFER_ASSET_INFORMATION_FAILED = 'DELETE_OFFER_ASSET_INFORMATION_FAILED';

export const INIT_ASSET_DATA_STARTED = 'INIT_ASSET_DATA_STARTED';
export const INIT_ASSET_DATA_COMPLETED = 'INIT_ASSET_DATA_COMPLETED';

export const LOAD_ASSET_DATA_STARTED = 'LOAD_ASSET_DATA_STARTED';
export const LOAD_ASSET_DATA_FINISHED = 'LOAD_ASSET_DATA_FINISHED';

export const RESET_DIRTY_INFO = 'RESET_DIRTY_INFO';

export const LOAD_SECOND_HAND_PROPERTIES_VISIBILITY_SUCCEEDED = 'LOAD_SECOND_HAND_PROPERTIES_VISIBILITY_SUCCEEDED';

export const LOAD_MANDATORY_PROPERTIES_CONFIGURED_SUCCEEDED = 'LOAD_MANDATORY_PROPERTIES_CONFIGURED_SUCCEEDED';
export const LOAD_MANDATORY_PROPERTIES_CONFIGURED_STARTED = 'LOAD_MANDATORY_PROPERTIES_CONFIGURED_STARTED';

export const LOAD_PROPERTY_DETAILS_STARTED = "LOAD_PROPERTY_DETAILS_STARTED";
export const LOAD_PROPERTY_DETAILS_SUCCESS = "LOAD_PROPERTY_DETAILS_SUCCESS";
